import { httpCreate } from './http';

const http = httpCreate('/srv/fs/custom-stat');

export const fsCustomstat = {
	getStatistics(activityId, params) {
		return http.get(`/${activityId}`, { params });
	},
};
